import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube} from "react-icons/fa";

const Footer = () => {
    const footerData = {
        sections: [
            {
                title: "COMMUNITY",
                body: "Community is where we find and create connections with others. It is through our worship that we gather as believers to tell and hear stories, affirm our faith, pray for one another and the world, and gather to lift praise to our LORD and Savior."
            },
            {
                title: "FELLOWSHIP",
                body: "We have a Commitment to Encouraging Fellowship and glorify God by providing the opportunities to share our triumphs and our struggles so that we all may be strengthen and commit to GOD the issues of the heart (Hebrews 10: 22-25; & I John 1:3, 7)."
            },
            {
                title: "GROWTH",
                body: "We invest in our Leadership to develop talents that increase their passion for CHRIST. We are dedicated to seeing each person, each family and community reach the fullest potential to win a world for CHRIST."
            }
        ],
        contact: {
            title: "CONTACT",
            address: "611 Amador Street, Vallejo, CA 94590",
            services: ["Sunday @ 10AM", "Wednesday Bible Study @ 6:30PM"],
            phone: "(707) 267-7729",
            email: "info@solidrockcathedral.org",
            membersLogin: {
                text: "Members Log-in",
                url: "/login"
            }
        },
        socialLinks: [
            { icon: <FaFacebook />, url: "https://www.facebook.com/www.solidrockcathedral.org/", label: "Facebook" },
            { icon: <FaInstagram />, url: "https://www.instagram.com/srcof/", label: "Instagram" },
            { icon: <FaTwitter />, url: "https://twitter.com/RockCathedral", label: "Twitter" },
            { icon: <FaYoutube />, url: "https://www.youtube.com/@solidrockcathedraloffaith2993/streams", label: "Youtube" }
        ]
    };

    return (
        <footer className="bg-gray-800 text-white py-8">
            <div className="container mx-auto px-4">
                {/* Social Media Section */}
                <div className="flex justify-center space-x-6 mb-6">
                    {footerData.socialLinks.map((link, index) => (
                        <a
                            key={index}
                            href={link.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-2xl text-gray-400 hover:text-white"
                            aria-label={link.label}
                        >
                            {link.icon}
                        </a>
                    ))}
                </div>

                {/* Top Sections */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                    {footerData.sections.map((section, index) => (
                        <div key={index}>
                            <h3 className="text-lg font-bold mb-2">{section.title}</h3>
                            <p className="text-sm leading-relaxed">{section.body}</p>
                        </div>
                    ))}
                </div>

                {/* Contact Section */}
                <div className="border-t border-gray-700 pt-6 text-center">
                    <h3 className="text-lg font-bold mb-2">{footerData.contact.title}</h3>
                    <p className="text-sm">{footerData.contact.address}</p>
                    <p className="text-sm">
                        {footerData.contact.services.map((service, index) => (
                            <span key={index}>
                                {service}
                                {index < footerData.contact.services.length - 1 && <br />}
                            </span>
                        ))}
                    </p>
                    <p className="text-sm mt-2">{footerData.contact.phone}</p>
                    <a href={`mailto:${footerData.contact.email}`} className="text-blue-400 hover:underline">
                        {footerData.contact.email}
                    </a>
                    <div className="mt-4">
                        <Link
                            to={footerData.contact.membersLogin.url}
                            className="inline-block bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded shadow"
                        >
                            {footerData.contact.membersLogin.text}
                        </Link>
                    </div>
                </div>

                {/* Footer Bottom */}
                <p className="text-sm text-gray-400 mt-6">
                    &copy; {new Date().getFullYear()} Solid Rock Cathedral of Faith. All rights reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
